import { render, staticRenderFns } from "./ChatSign.vue?vue&type=template&id=572effca&scoped=true"
import script from "./ChatSign.vue?vue&type=script&lang=js"
export * from "./ChatSign.vue?vue&type=script&lang=js"
import style0 from "./ChatSign.vue?vue&type=style&index=0&id=572effca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572effca",
  null
  
)

export default component.exports